import React, {useState, useEffect} from "react";
import { ChoixPeriodeLayout } from "../shared/ChoixPeriodeLayout";

export const ChoixPeriodeCesuMulti = () => {
const PRESTATION_NAME="cesuMulti";
  return (
    <ChoixPeriodeLayout prestationName={PRESTATION_NAME}/>
  );
};
